import { ApolloClient, InMemoryCache, ApolloLink, HttpLink, concat } from '@apollo/client';

export const cache = new InMemoryCache();
const httpLink = new HttpLink({ uri: process.env.REACT_APP_API });
const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
  operation.setContext({
    headers: {
      authorization: localStorage.getItem('userToken') || null,
      'x-api-key': process.env.REACT_APP_API_KEY,
    },
  });

  return forward(operation);
});
export const client = new ApolloClient({
  link: concat(authMiddleware, httpLink),
  cache,
  connectToDevTools: true,
});
client.defaultOptions = { query: { fetchPolicy: 'network-only' } };
export default client;
